var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUnlocked = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 16,
  viewBox: "0 0 12 16",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M6 0a4 4 0 0 0-4 4v2l-.141.005A2 2 0 0 0 0 8v6c0 1.105.902 2 2.009 2H9.99A2 2 0 0 0 12 14V8c0-1.105-.902-2-2.009-2H4V4l.005-.15A2 2 0 0 1 8 4h2a4 4 0 0 0-4-4M5 10h2v2H5z"
})));
export default SvgUnlocked;